<template>
  <div class="container">
    <div class="white-box">
      <p class="pan-text">
        Shared file: test <br>
        Link: https://pan.baidu.com/s/1pHNGxNK4TO9l7vZYvhKDZg <br>
        Password: awsd
      </p>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  position: relative;
  z-index: 999;
}

.white-box {
  border: 2px solid #ffffff;
  padding: 24px 36px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.08);
}

.pan-text {
  color: #ffffff;
  font-size: 17px;
  line-height: 1.9;
  text-align: center;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.7);
  margin: 0;
}
</style>